import React from 'react';
import styled from 'styled-components';

interface TaskDetailsSectionProps {
    title: string;
    children: React.ReactNode;
    actions?: React.ReactNode;
    className?: string;
}

const SectionCard = styled.div`
    background: white;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.app.borderColor};
    overflow: hidden;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    border-bottom: 1px solid ${(props) => props.theme.app.borderColor};
    background: ${(props) => props.theme.app.backgroundColorBase};

    h3 {
        margin: 0;
        font-size: 14px;
        font-weight: ${(props) => props.theme.font.bold};
    }
`;

const SectionBody = styled.div`
    padding: 20px;
`;

/**
 * TaskDetailsSection - Atomic component for displaying sections in task detail pages
 * Provides consistent card layout with header and body
 */
export const TaskDetailsSection: React.FC<TaskDetailsSectionProps> = ({ title, children, actions, className }) => {
    return (
        <SectionCard className={className}>
            <SectionHeader>
                <h3>{title}</h3>
                {actions && <div>{actions}</div>}
            </SectionHeader>
            <SectionBody>{children}</SectionBody>
        </SectionCard>
    );
};

export default TaskDetailsSection;
